import React, {useEffect, useState} from 'react';
import {ModelReplacementsTable} from "../../../../components/UI/table/model-estimate/model/ModelReplacementsTable";
import {useParams} from "react-router-dom";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import {constantsErrorMessages} from "../../../../Constants";
import {Box} from "@mui/system";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import ModelReplacementService from "../../../../API/model-estimate/model/ModelReplacementService";

const ModelReplacement = () => {
    const params = useParams();
    const [data, setData] = useState([]);
    const [alertData, setAlertData] = useState({});
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })

    useEffect(() => {
        getStartPageSize()
        ModelReplacementService.getAllByMaterialId(params.id).then(function (response) {
            let data = response.data;
            setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
            setData(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData("organization/models/replacements", "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData["organization/models/replacements"]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    const handleCloseAlert = () => {
        setAlertData((alert) => {
            return {...alert, open: false}
        })
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={`Соответствие материалов`}
                path={[{name: "Главная", href: "/"}, {name: "Настройки", href: "/settings"}]}/>
            <ModelReplacementsTable
                materialId={params.id}
                data={data}
                setData={setData}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
                handleModalAlert={handleModalAlert}
            />
            <ModalAlert data={alertData} onClose={handleCloseAlert}/>
        </Box>
    );
};

export default ModelReplacement;